<template>
  <div>
    <v-row class="customer-detail custom-border-to">
      <v-col md="12" sm="12" class="pt-0">
        <v-skeleton-loader
          class="custom-skeleton"
          v-if="pageLoading"
          type="table-tbody"
        >
        </v-skeleton-loader>
        <v-simple-table v-else class="simple-table">
          <template v-slot:default>
            <thead>
              <tr style="background-color: #f3f6f9; color: #24326d">
                <th class="simple-table-th">#</th>
                <th class="simple-table-th">Name</th>
                <th class="simple-table-th">Primary</th>
                <th class="simple-table-th">Email Address</th>
                <th class="simple-table-th">Position</th>
                <th class="simple-table-th">Mobile Number</th>
                <th class="simple-table-th">DID</th>
                <th class="simple-table-th">Landline</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(person, index) in rowData"
                :key="index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                }"
              >
                <td
                  link
                  v-on:click="selectLead(person.id)"
                  class="font-size-14 font-weight-500 text-lowercase"
                >
                  {{ index + 1 }}
                </td>

                <td
                  link
                  v-on:click="selectLead(person.id)"
                  class="font-size-14 font-weight-500 text-capitalize"
                >
                  {{ person.full_name }}
                  <div>
                    <v-chip
                      small
                      color="blue white--text"
                      label
                      class=""
                      v-if="person.default == 1"
                    >
                      <span class="font-size-16 font-weight-500">
                        Primary
                      </span>
                    </v-chip>
                  </div>
                </td>

                <td link class="font-size-14 font-weight-500 text-capitalize">
                  <div>
                    <v-switch
                      color="#4caf50"
                      :readonly="isSwitchDisabled"
                      :input-value="person.default"
                      @click="handleSwitchClick(index, person)"
                      inset
                    >
                    </v-switch>
                  </div>
                </td>

                <td
                  link
                  v-on:click="selectLead(person.id)"
                  class="font-size-14 font-weight-500 text-lowercase"
                >
                  <template v-if="person && person.primary_email">
                    <v-icon small class="me-1">mdi-email</v-icon
                    >{{ person.primary_email }}
                  </template>
                  <em v-else class="text-muted"> no email address </em>
                </td>

                <td
                  link
                  v-on:click="selectLead(person.id)"
                  class="font-size-14 font-weight-500 text-lowercase"
                >
                  <template v-if="person && person.designation">
                    <v-icon small class="me-1">mdi-account-tie </v-icon
                    >{{ person.designation }}
                  </template>
                  <em v-else class="text-muted"> no position </em>
                </td>

                <td
                  link
                  v-on:click="selectLead(person.id)"
                  class="font-size-14 font-weight-500"
                >
                  <template v-if="person && person.primary_phone">
                    <v-icon small>mdi-phone</v-icon>{{ person.primary_phone }}
                  </template>
                  <em v-else class="text-muted"> no number</em>
                </td>
                <td
                  link
                  v-on:click="selectLead(person.id)"
                  class="font-size-14 font-weight-500"
                >
                  <template v-if="person && person.did">
                    <v-icon small>mdi-phone</v-icon>{{ person.did }}
                  </template>
                  <em v-else class="text-muted"> no DID</em>
                </td>
                <td
                  link
                  v-on:click="selectLead(person.id)"
                  class="font-size-14 font-weight-500"
                >
                  <template v-if="person && person.landline">
                    <v-icon small>mdi-phone </v-icon>{{ person.landline }}
                  </template>
                  <em v-else class="text-muted"> no landline </em>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <PrimaryConfirmTemplate :primary-dialog="primaryConfirm">
      <template v-slot:title>Primary Confirmation</template>
      <template v-slot:text>
        <h3 class="font-size-16 font-weight-500 delete-text">
          Are you sure, you want to make
          <span class="red--text">{{ primaryPerson?.full_name }}</span> Primary
          Contact Person ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="handleCancel(primaryPerson)"
          >No! Cancel</v-btn
        >
        <v-btn
          color="red lighten-1 white--text"
          v-on:click="makePrimary(primaryPerson)"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Proceed</v-btn
        >
      </template>
    </PrimaryConfirmTemplate>
  </div>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus } from "@/core/lib/message.lib";
import PrimaryConfirmTemplate from "@/view/pages/partials/Primary";
export default {
  name: "contact-persons",
  title: "Lead",
  mixins: [CommonMixin],
  props: {
    lead: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },

    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rowData: [],
      selectedRows: [],
      primaryIndex: null,
      isSwitchDisabled: true,
      lead_id: null,
      primaryConfirm: false,
      primaryPerson: null,
    };
  },
  components: {
    PrimaryConfirmTemplate,
  },
  watch: {
    selectedRows(param) {
      this.$emit("selectedRows", param);
    },
    lead: {
      deep: true,
      immediate: true,
      handler() {
        this.assignData();
      },
    },
  },
  methods: {
    async makePrimary(person) {
      const _this = this;
      const person_id = person.id;
      _this.isSwitchDisabled = false;

      const url = `leads/${_this.lead_id}/contact-person/${person_id}`;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: url,
          data: {
            type: "lead",
          },
        })
        .then(() => {
          _this.$emit("success");
          _this.primaryIndex = null;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
          _this.primaryIndex = null;
          _this.primaryConfirm = false;
          _this.isSwitchDisabled = true;
        });
    },
    selectLead(param) {
      this.$emit("selectLead", param);
    },
    assignData() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.lead.persons) === false) {
        _this.rowData = _this.lead.persons;
        _this.lead_id = _this.lead.id;
      }
    },

    handleSwitchClick(index, person) {
      this.primaryIndex = index;
      this.primaryPerson = person;

      if (!this.primaryPerson.default) {
        this.primaryConfirm = true;
      }
    },

    handleCancel(person = null) {
      if (person) {
        const original = person.default;
        person.default = original == 1 ? 0 : 1;
        this.$nextTick(() => {
          person.default = original;
        });
      }
      this.primaryIndex = null;
      this.primaryConfirm = false;
    },

    activeInactive(data) {
      if (_this.lead.activated == 0) {
        return false;
      }
      if (data.default == 1) {
        ErrorEventBus.$emit(
          "update:error",
          "The Primary Contact Person can’t be In-Active."
        );
        return false;
      }

      const _this = this;
      if (data.activated == false) {
        data.activated = 0;
      } else {
        data.activated = 1;
      }
      _this.$store
        .dispatch(PATCH, {
          url: `single-person/${data.activated}/${data.id}`,
          data: {
            id: data.id,
            status: data.activated,
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {});
    },
  },
  mounted() {
    const _this = this;
    _this.assignData();
    _this.$root.$on("clearSelection", () => {
      _this.selectedRows = [];
    });
  },
  beforeDestroy() {
    /*this.$root.$off("clearSelection");*/
  },
  computed: {
    selectedAll: {
      set(param) {
        this.selectedRows = [];
        if (param && this.rowData.length) {
          for (let i = this.rowData.length - 1; i >= 0; i--) {
            this.selectedRows.push(this.rowData[i].id);
          }
        }
      },
      get() {
        let totalItems = this.rowData.length;
        return totalItems > 0 ? this.selectedRows.length === totalItems : false;
      },
    },
  },
};
</script>
